var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section-layout',{attrs:{"navbarTheme":_vm.navBarTheme,"sidebar-theme":"dark"}},[_c('div',{staticClass:"white"},[_c('home-ideas-place-start')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }